import { render } from "./UserProfileButton.vue?vue&type=template&id=f30f3e66&scoped=true"
import script from "./UserProfileButton.vue?vue&type=script&lang=js"
export * from "./UserProfileButton.vue?vue&type=script&lang=js"

import "./UserProfileButton.vue?vue&type=style&index=0&id=f30f3e66&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f30f3e66"]])

export default __exports__